import { createRouter, createWebHistory } from "vue-router";
import LoginUser from "../public/pages/loginUser.vue";
import Private from "../private/private.vue";
import dashboard from "../private/pages/dashboard-home/dashboard.vue";
import contributionSchedule from "../private/pages/schedules/contribution-schedule";
import employeeList from "../private/pages/employees/employee-list";
import employeeDetails from "../private/pages/employees/employee-details";
import exitedEmployee from "../private/pages/employees/exited-employee";
import paymentHistory from "../private/pages/payment-history/payment-history";
import tickets from "../private/pages/tickets/tickets";
import profile from "../private/pages/profile/profile";
import paymentHistoryDetails from "../private/pages/payment-history/payment-history-details";
import GeneratePaymentHistory from "@/private/pages/payment-history/generate-payment-history.vue";

export const isLoggedIn = () => {
  return localStorage.getItem("token");
};

const routes = [
  { path: "/", component: LoginUser },
  { path: "/generate-remittance-proof", component: GeneratePaymentHistory },
  {
    path: "/private",
    component: Private,
    beforeEnter(to, from, next) {
      if (isLoggedIn()) {
        next();
      } else {
        next("/");
      }
    },
    children: [
      { path: "/user/dashboard", component: dashboard, name: "dashboard" },
      {
        path: "/user/contribution-schedule",
        component: contributionSchedule,
        name: "contribution-schedule",
      },
      {
        path: "/user/employee-list",
        component: employeeList,
        name: "employee-list",
      },
      {
        path: "/user/employee-details/:pin",
        component: employeeDetails,
        name: "employee-details",
      },
      {
        path: "/user/exited-employees",
        component: exitedEmployee,
        name: "exited-employees",
      },
      {
        path: "/user/payment-history",
        component: paymentHistory,
        name: "payment-history",
      },
      {
        path: "/user/payment-history-details/:id",
        component: paymentHistoryDetails,
        name: "payment-history-details",
      },
      { path: "/user/tickets", component: tickets, name: "tickets" },
      { path: "/user/profile", component: profile, name: "profile" },
      {
        path: "/:pathMatch(.*)*",
        redirect: "/",
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
